<script setup>
  import { defineProps } from 'vue'
  const props = defineProps({
    text: String,
  })
</script>
<template>
  <div
    class="float-right cursor-help w-[1em] h-[1em] leading-none rounded-full bg-white/40 text-black/60 text-center ml-2"
    :title="props.text"
  >ℹ</div>
</template>
